import actionTypes  from './actionTypes';

const setEmail = email => {
    return {
        type: actionTypes.SET_EMAIL,
        payload: email
    };
};

const setCode = code => {
    return {
        type: actionTypes.SET_CODE,
        payload: code
    };
};

const sendError = error => {
    return {
        type: actionTypes.SEND_ERROR,
        payload: error
    }
}

const logOut = () => {
    return {
        type: actionTypes.LOGOUT
    }
}

const setDomain = domain => {
    return {
        type: actionTypes.SET_DOMAIN,
        payload: domain
    }
}

export {setEmail, setCode, sendError, logOut, setDomain};
